import CustomTag from 'components/CustomTag'
import React from 'react'

const DriveStatus = ({ status }) => {
  let colorType
  let tagMessage

  if (status === 'REQUESTED' || status === 'RESCHEDULE_REQUESTED') {
    colorType = 'grey'
    if (status === 'REQUESTED') {
      tagMessage = 'Requested'
    } else {
      tagMessage = 'Reschedule Requested'
    }
  } else if (status === 'CONFIRMED' || status === 'COMPLETED') {
    colorType = 'green'
    if (status === 'CONFIRMED') {
      tagMessage = 'Confirmed'
    } else {
      tagMessage = 'Completed'
    }
  } else if (status === 'PENDING' || status === 'ONGOING') {
    colorType = 'orange'
    if (status === 'PENDING') {
      tagMessage = 'Pending'
    } else {
      tagMessage = 'Ongoing'
    }
  } else if (status === 'CANCELLED') {
    colorType = 'red'
    tagMessage = 'Cancelled'
  }

  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false} />
  )
}

export default DriveStatus
